<script>

import Vue from 'vue'
import VueSession from 'vue-session'
import {config} from '../../config'

Vue.use(VueSession)

export default{
	name:'sharing',
	created:function(){
		(function(d, s, id){
	     var js, fjs = d.getElementsByTagName(s)[0];
	     if (d.getElementById(id)) {return;}
	     js = d.createElement(s); js.id = id;
	     //js.src = "https://connect.facebook.net/en_US/sdk/debug.js";
	     js.src = "https://connect.facebook.net/en_US/sdk.js";
	     fjs.parentNode.insertBefore(js, fjs);
	   }(document, 'script', 'facebook-jssdk'));

		window.fbAsyncInit=function(){
			FB.init({
				appId:config.fbAppId,
				xfbml: true,
     	 		version: 'v3.0'
			});
		}
	},
	methods:{
		shareCurrentPage(){
			var domainUrl=window.location.href.split("/");
			var url=config.shareUrl+mepaConfig.promoId+"&shareType=PROMO";
			FB.ui({
				method:'share',
				href:url
			});
		},
		shareResult(){
			var quizToken = this.$session.get('token');
			var url;
			if(quizToken){
				url=config.shareUrl+quizToken+"&shareType=QUIZ";
			}else{
				url=config.shareUrl+mepaConfig.promoId+"&shareType=PROMO";
			}
			
			FB.ui({
				method:'share',
				href:url
			});
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/shared/sharing/Sharing.vue